export const ACCOUNT_LIST = {
  ADDRESSES: 'addresses',
  OFFERS: 'offers',
  ORDERS: 'orders',
  PAYMENTS: 'payments',
  PREFERENCES: 'preferences',
  PROFILE: 'profile',
  SUPPORT: 'support',
  WANTS: 'wants',
};

export const OTP_METHODS = { EMAIL: 'email', PHONE: 'phone' };

export const PHONE_2FA_METHODS: { SMS: 'SMS'; VOIP: 'VOIP' } = {
  SMS: 'SMS',
  VOIP: 'VOIP',
};
